import { useCallback, useMemo } from 'react';

import { useScreenQuery } from '@april9au/stack9-ui';

type OptionSetDropdownProps = {
  requirement: number;
  setOptionSet: any;
  optionSet?: number;
};

const OptionSetDropdown = ({
  requirement,
  setOptionSet,
  optionSet,
}: OptionSetDropdownProps) => {
  const { data } = useScreenQuery<any>('getOptionsetByRequirement', {
    vars: {
      requirementId: requirement,
      page: 0,
      limit: 10,
    },
  });

  const optionsOptionSet = useMemo(
    () =>
      data?.results?.map((opt: any) => ({
        label: opt.option,
        value: opt.id,
      })),
    [data],
  );

  const onChangeOptionSet = useCallback(() => {
    const selectedElement = document.getElementById('option_set_id') as any;
    setOptionSet(selectedElement?.value);
  }, [setOptionSet]);

  return (
    <div className="block text-sm  leading-6 text-gray-900">
      <label htmlFor="option_set_id">Option set</label>

      <div className="relative">
        <select
          required
          onChange={onChangeOptionSet}
          className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
          id="option_set_id"
          style={{ minWidth: '100%' }}
        >
          <option value="" disabled selected>
            Select option
          </option>
          {optionsOptionSet &&
            optionsOptionSet.map((opt: any) => (
              <option
                key={opt.value}
                selected={opt.value === optionSet}
                value={opt.value}
              >
                {opt.label}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default OptionSetDropdown;
